import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AdhocAdvancePaymentDTO  {
    _originalTypeClassName = "zERP.BO.AdhocAdvancePaymentDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AdhocAdvancePaymentDTO.translate = translateService;
}
this.Id = null;
this.Amount = null;
this.SubmitionDate = null;
this.PaymentDate = null;
this.ClearanceDate = null;
this.AdhocAdvancePaymentDTOKey = null;
this._key = this.AdhocAdvancePaymentDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Amount:any;
SubmitionDate:any;
PaymentDate:any;
ClearanceDate:any;
private _AdhocAdvancePaymentDTOKey:any;
get AdhocAdvancePaymentDTOKey(): any {
    return this._AdhocAdvancePaymentDTOKey;
  }
set AdhocAdvancePaymentDTOKey(value: any) {
    this._AdhocAdvancePaymentDTOKey = value;
    this._key = value;
  }

static Assign(aap: any): any{let aapDTO = new Domain.AdhocAdvancePaymentDTO();
aapDTO.Id = aap?.Id;
aapDTO.PaymentDate = aap?.PaymentDate;
aapDTO.SubmitionDate = aap?.SubmitionDate;
aapDTO.Amount = aap?.Amount;
aapDTO.ClearanceDate = aap?.ClearanceDate;
return aapDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AdhocAdvancePaymentDTOKey == null || $this.AdhocAdvancePaymentDTOKey == 0;
            }


}